import { useEffect } from "react";

/**
 * Directly sets inline styles on a DOM element for the lifetime of the component,
 * then restores the original values on unmount. Inline styles always win over
 * stylesheets regardless of specificity or load order.
 */
export function useOverrideStyles(
  selector: string,
  styles: Record<string, string>,
) {
  useEffect(() => {
    const el = document.querySelector(selector) as HTMLElement | null;
    if (!el) return;

    const original: Record<string, string> = {};
    Object.keys(styles).forEach((key) => {
      original[key] = (el.style as any)[key];
      (el.style as any)[key] = styles[key];
    });

    return () => {
      Object.keys(original).forEach((key) => {
        (el.style as any)[key] = original[key];
      });
    };
  }, [selector]);
}
